export const BRAND_ROUTE_LAST_PART = '.*';
